<template>
  <svg
    :class="customClass"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M3.25 20.5781V7.07812H7.25V3.07812H16.75V11.0781H20.75V20.5781H13.25V16.5781H10.75V20.5781H3.25ZM4.75 19.0781H7.25V16.5781H4.75V19.0781ZM4.75 15.0781H7.25V12.5781H4.75V15.0781ZM4.75 11.0781H7.25V8.57812H4.75V11.0781ZM8.75 15.0781H11.25V12.5781H8.75V15.0781ZM8.75 11.0781H11.25V8.57812H8.75V11.0781ZM8.75 7.07812H11.25V4.57812H8.75V7.07812ZM12.75 15.0781H15.25V12.5781H12.75V15.0781ZM12.75 11.0781H15.25V8.57812H12.75V11.0781ZM12.75 7.07812H15.25V4.57812H12.75V7.07812ZM16.75 19.0781H19.25V16.5781H16.75V19.0781ZM16.75 15.0781H19.25V12.5781H16.75V15.0781Z" fill="#1E264C"/>

  </svg>
</template>

<script>
export default {
  name: "ApartmentIcon",
  props: {
    customClass: {
      type: String,
      default: "w-6 h-6",
    },
  },
};
</script>
